<div class="footerContainer" [ngClass]="{ar: translate.currentLang =='ar'}">
    <div class="container">
        <div class="topFooter">
            <div class="row pt-5">
                <div class=" col-12 col-md-6 col-lg-3"> 
                    <div class="logo">
                        <img src="assets/icons/travelNow-logo.svg" alt="">
                    </div>
                    <p class="Logo__wrapper">{{'footer.text' | translate}}</p>
                    <span class="linkTitle">{{'footer.follow' | translate}}</span>
                    <div class="links d-flex justify-content-start">
                        <a href="https://facebook.com"  target="_blank" class="facebookIcon">
                            <img src="../../assets/img/albaraq/facebook.png" width="25" height="42">
                        </a> 
                        <a href="https://www.instagram.com/travelnowae?igsh=ZGtlZWNncmNuaW9n" target="_blank">
                            <img src="../../assets/img/albaraq/Instgram.png" width="25" height="42">
                        </a>
                        <a href="https://linkedin.com/company" target="_blank">
                            <img src="../../assets/img/albaraq/linkedIn.png" width="25" height="42">
                        </a>
                    </div>
                </div>
                <div class=" col-12 col-md-6 col-lg-3 contactUs">
                    <h4 [routerLink]="['/Contact']" class="static">{{'footer.contactUs' | translate}}</h4>
                    <div class="contactUs__wrapper d-flex">
                        <div class="contact_Link d-flex" (click)="call()">
                            <fa-icon class="icon phone" [icon]="faPhone"></fa-icon>
                            <a target="_blank" href="tel: 971501064191" dir="ltr">{{"footer.phone" | translate}}</a>
                        </div>
                        <div class="contact_Link d-flex">
                            <fa-icon class="icon" [icon]="faMapMarkerAlt"></fa-icon>
                            <a [routerLink]="['/Contact']">{{"footer.address" | translate}}</a>
                        </div>

                        <div class="contact_Link d-flex">
                            <fa-icon class="icon" [icon]="faEnvelope"></fa-icon>
                            <a href="mailto: letsgo@travelnow.global">{{"footer.email" | translate}}</a>
                        </div>
                        <div class="contact_Link d-flex" (click)="whatsApp()">
                            <fa-icon class="icon" [icon]="faWhatsapp"></fa-icon>
                            <a target="_blank" href="https://api.whatsapp.com/send?phone=971501064191">{{"footer.whatsApp" | translate}}</a>
                        </div>
                    </div>
                </div>
                <div class=" col-12 col-md-6 col-lg-3 support">
                    <h4 class="static">{{'footer.support' | translate}}</h4>
                    <div class="support__wrapper d-flex">
                        <a class="support_link" [routerLink]="['/aboutUs']">{{"aboutUs.aboutTxt" | translate}}</a>

                        <a class="support_link" [routerLink]="['/Contact']">{{'footer.contactUs' | translate}}</a>
                       

                        <a class="support_link" [routerLink]="['/privacyPolicy']">{{"footer.privacyPolicy" |
                            translate}}</a>
                        <a class="support_link" [routerLink]="['/termsOfuse']">{{"footer.terms" | translate}}</a>
                    </div>
                </div>
                <div class=" col-12 col-md-6 col-lg-3 payment">
                    <h4 >{{'footer.payment' | translate}}</h4>
                    <div class="payment__wrapper">
                        <div class="row justify-content-center">
                            <button class="payment_Links visaBtn btn col-4">
                                <img src="../../assets/footer/Visa.svg" width="25" height="35"/>
                            </button>
                            <button class="payment_Links btn col-4">
                                <img src="../../assets/footer/MasterCard.svg" width="25" height="35"/>
                            </button>
                          
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
    <div class="bottomFooter">
        <div class="container">
            <span>{{'footer.copyRight' | translate}}</span>
        </div>
    </div>
</div>